// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon {\n  cursor: pointer;\n}\n.icon--hover {\n  cursor: pointer;\n}", "",{"version":3,"sources":["webpack://./src/components/icon/Icon.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;AACI;EACI,eAAA;AACR","sourcesContent":[".icon {\r\n    cursor: pointer;\r\n\r\n    &--hover {\r\n        cursor: pointer;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
